import React from "react";
import Bar, {BarButton} from "../uiUtils/Bar";

export default function NavBar({callbacks, wizard, mcc, ...props}){

    const {openWizard, clearAdvertisers, loadAdSeller, loginToMcc} = callbacks;

    return <Bar {...props}>
        {loginToMcc &&
            <BarButton onClick={()=>loginToMcc()}>Login into MCC</BarButton>}
        {openWizard &&
            <BarButton onClick={()=>openWizard(new mcc.Asset(template))}
                >load MCC template</BarButton>}
        {clearAdvertisers &&
            <BarButton onClick={()=>clearAdvertisers()}>Clear Advertisers</BarButton>}
        {loadAdSeller &&
            <BarButton onClick={()=>{
                    wizard.importAdSeller(adSellerData);
                    loadAdSeller(adSellerData);
                }
            }>load Pulse data</BarButton>}
    </Bar>
}

const template = {
    file_base: "C212QW12006R",
    height: 250,
    heightInches: 3.472,
    medium: "web",
    name: "C212QW12006R",
    width: 300,
    widthInches: 4.167,
    file_name: 'C212QW12006R.QXP',
    metro_type: 'Spec Ad',
    file_ext: 'psd'
}


const adSellerData = {
    "user": {
        "name": "Brian Martin",
        "id": 7798,
        "email": "knapp@paper.net"
    },
    "presentation": {
      //  "id": "104",
     //   "ad_id": "S2104W18001R"
    },
    "advertiser": {
        "name": "Bingo Hardware Thrift",
        "address": {
            "street": "1 Seller St",
            "city": "Kansas City",
            "state": 'Kansas',
            "zip": null
        },
        "phone": '123-456-7890',
        "web": 'www.thrifty.ace',
        "id": "545477",
        "business": {
            "type": "Hardware Store",
            "id": ""
        },
        "metroBiz" : {
            "keyword":["hardware","wiztest"],
            "type": "Hardware"
        }
    },
    "auth": {
        "time": "1591994354",
        "token": "24996e2de1c667d0bdbe9c4f0a21f75fcf2ef034"
    },
    "return": 'https://backto.adseller.site/presentation?id=102'
};